import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { FlexColumn, FlexRow } from '../../../atoms/layout/Flex'
import useYup from '../../../../hooks/useYup'
import VisitorRegistrationWorkCategoriesForm from './WorkCategoriesForm'
import VisitorRegistrationQualificationsForm from './QualificationsForm'
import VisitorRegistrationSurveysForm from './SurveysForm'
import Button from '../../../atoms/inputs/Button'
import Form from '../../../atoms/inputs/Form'
import {
  VisitorRegistrationForm as VisitorRegistrationFormType,
  VisitorRegistrationAnswers,
} from '../../../../types/Company'
import { CompanyActions } from '../../../../store/company'

type Props = {
  form: VisitorRegistrationFormType
}

export default function VisitorRegistrationForm(props: Props) {
  const { form: propsForm } = props
  const yup = useYup()
  const form = useForm<VisitorRegistrationAnswers>({
    resolver: yupResolver(
      yup.object().shape({
        survey1: yup.number().required('必須項目です'),
        survey2: yup.number().required('必須項目です'),
        survey3: yup.number().required('必須項目です'),
        survey4: yup.number().required('必須項目です'),
        survey5: yup.number().required('必須項目です'),
        survey6: yup.number().required('必須項目です'),
        survey6Name: yup.string().when('survey6', {
          is: 1,
          then: (schema) => schema.required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
        survey7: yup.number().required('必須項目です'),
        survey7Name: yup.string().when('survey7', {
          is: 1,
          then: (schema) => schema.required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
        survey8: yup.number().required('必須項目です'),
        survey9: yup.number().required('必須項目です'),
        survey10: yup.number().required('必須項目です'),
        survey11: yup.number().required('必須項目です'),
        survey12: yup.number().required('必須項目です'),
        survey13: yup.number().required('必須項目です'),
        survey14: yup.number().required('必須項目です'),
        survey15: yup.number().required('必須項目です'),
        workCategoryOtherText: yup.string().when('workCategoryOther', {
          is: true,
          then: yup.string().required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
        qualificationAOtherText: yup.string().when('qualificationAOther', {
          is: true,
          then: yup.string().required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
        qualificationBOtherText: yup.string().when('qualificationBOther', {
          is: true,
          then: yup.string().required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
        qualificationCOtherText: yup.string().when('qualificationCOther', {
          is: true,
          then: yup.string().required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
        qualificationDOtherText: yup.string().when('qualificationDOther', {
          is: true,
          then: yup.string().required('必須項目です'),
          otherwise: yup.string().notRequired(),
        }),
      })
    ),
    defaultValues: propsForm.answers ?? undefined,
  })
  const dispatch = useDispatch()

  const handleSave = useCallback(
    (params: VisitorRegistrationAnswers) => {
      dispatch(CompanyActions.saveVisitorRegistrationAnswers({ answers: params }))
    },
    [dispatch]
  )

  return (
    <FormProvider {...form}>
      <Form onSubmit={form.handleSubmit(handleSave)}>
        <FlexColumn>
          <VisitorRegistrationSurveysForm />
          <VisitorRegistrationWorkCategoriesForm />
          <VisitorRegistrationQualificationsForm />
          <FlexRow>
            <Button type="submit">保存</Button>
          </FlexRow>
        </FlexColumn>
      </Form>
    </FormProvider>
  )
}
